<template>
    <div class="evo-h-full evo-w-full evo-flex-1 evo-flex evo-bg-neutral-2">
        <slot></slot>
    </div>
</template>

<script setup></script>
